"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLink = exports.setSizing = exports.setHover = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const setFont = (props) => {
    var _a, _b, _c, _d, _e;
    const color = (_a = props.color) !== null && _a !== void 0 ? _a : '#007185';
    const fontFamily = (_b = props.fontFamily) !== null && _b !== void 0 ? _b : props.theme.typography.base.fontFamily;
    const fontSize = (_c = props.fontSize) !== null && _c !== void 0 ? _c : props.theme.typography.base.fontSize;
    const fontStyle = (_d = props.fontStyle) !== null && _d !== void 0 ? _d : props.theme.typography.base.fontStyle;
    const fontWeight = props.fontWeight;
    const lineHeight = props.lineHeight;
    const textDecoration = (_e = props.textDecoration) !== null && _e !== void 0 ? _e : 'none';
    return (0, styled_components_1.css) `
    color: ${color};
    font-family: ${fontFamily};
    font-size: ${fontSize};
    font-style: ${fontStyle};
    font-weight: ${fontWeight};
    line-height: ${lineHeight};
    text-decoration: ${textDecoration};
  `;
};
const setHover = (props) => {
    var _a, _b;
    const colorHover = (_a = props.colorHover) !== null && _a !== void 0 ? _a : '#c45500';
    const textDecorationHover = (_b = props.textDecorationHover) !== null && _b !== void 0 ? _b : 'underline';
    return (0, styled_components_1.css) `
    &:hover {
      color: ${colorHover};
      text-decoration: ${textDecorationHover};
    }
  `;
};
exports.setHover = setHover;
const setSizing = (props) => {
    var _a;
    const height = props.height;
    const margin = props.margin;
    const padding = props.padding;
    const width = (_a = props.width) !== null && _a !== void 0 ? _a : '100%';
    return (0, styled_components_1.css) `
    height: ${height};
    margin: ${margin};
    padding: ${padding};
    width: ${width};
  `;
};
exports.setSizing = setSizing;
exports.StyledLink = styled_components_1.default.a `
  cursor: pointer;
  ${setFont}
  ${exports.setHover}
  ${exports.setSizing}
`;
